import useWorkspaceApiCall from 'hooks/useWorkspaceApiCall';
import { useCallback, useEffect, useState } from "react";
import { LessonFlat } from "models/LessonFlat";
import { getLessons } from "api/services/lesson-service";

export const useGetLessons = () => {
    const [lessons, setLessons] = useState<LessonFlat[]>([]);
    const { callAPI, loading } = useWorkspaceApiCall(getLessons, '', 'getLessons.error');

    const fetchLessons = useCallback(async () => {
        const resp = await callAPI('');

        if (resp?.success && resp.data) {
            setLessons(resp.data);
        }
    }, [callAPI]);

    useEffect(() => {
        fetchLessons();
    }, [fetchLessons]);

    return { lessons, fetchLessons, fetchingLessons: loading };
}